export default {
  HOME: 'home',
  COURSES: 'courses',
  CALENDAR: 'calendar',
  DAY: 'day',
  LOGOUT: 'logout'
}
